import { BRAND } from '../config/branding';

export const customerCarePhoneNumber = BRAND.contact.customerCarePhone;
export const supportEmail = BRAND.contact.customerCareEmail;
